export const useExternalLink = () => {
    const formatLink = (url) => {
        if (!url) return '#'
        const trimmedUrl = url.trim()
        if (/^https?:\/\//i.test(trimmedUrl)) {
            return trimmedUrl
        }

        if (trimmedUrl.startsWith('//')) {
            return trimmedUrl
        }
        return `https://${trimmedUrl}`
    }
    return {
        formatLink
    }
}
